import { Component, Input, OnInit } from "@angular/core";
import { EMajorationType } from "apps/idl/src/model/EMajorationType";
import { PopoverService } from "../../../shared/services/popover.service";
import { InformationPopoverComponent } from "../../../shared/components/information-popover/information-popover.component";

@Component({
	selector: "di-majoration",
	templateUrl: "./majoration.component.html",
	styleUrls: ["./majoration.component.scss"],
})
export class MajorationComponent implements OnInit {
	
	constructor(private svcPopover: PopoverService) {}

	public ngOnInit(): void {}

	@Input() type: EMajorationType | "" = "";
	@Input() priceLabel = "";
	// True si c'est une indemnité
	@Input() indemnity = false;
	@Input() indemnityLabel = "";
	@Input() disabled :boolean = false;
	// True pour afficher l'icon seulement
	@Input() icon: boolean = false;
	// True pour afficher le prix
	@Input() price: boolean = true;
	// True pour afficher le bouton i
	@Input() information: boolean = false;

	getMajorationDetails() {
		if (this.indemnity) {
			return {
				iconName: "directions_car",
				customIconeName: "",
				label: this.indemnityLabel,
			};
		} else {
			switch (this.type) {
				case EMajorationType.NightFirstHalf:
					return {
						iconName: "bedtime",
						customIconeName: "",
						label: "Nuit (20h -23h & 5h-8h)",
					};
				case EMajorationType.NightSecondHalf:
					return {
						iconName: "night_sight_max",
						customIconeName: "",
						label: "Nuit (23h - 5h)",
					};
				case EMajorationType.Mau:
					return {
						iconName: "",
						customIconeName: "mau",
						label: "Majoration acte unique",
					};
				case EMajorationType.Mci:
					return {
						iconName: "",
						customIconeName: "mci",
						label: "Majoration de coordination infirmière",
					};
				case EMajorationType.Mie:
					return {
						iconName: "",
						customIconeName: "mie",
						label: "Majoration Enfant de moins de 7 ans",
					};
				case EMajorationType.SundayAndHolyday:
					return {
						iconName: "",
						customIconeName: "md",
						label: "Dimanche / jour férié",
					};
				case EMajorationType.Mip:
					return {
						iconName: "",
						customIconeName: "mip",
						label: "Majoration infirmier Pratique avancée",
					};
				default:
					return {
						iconName: "",
						customIconeName: "",
						label: "",
					};
			}
		}
	}

	getIconMode() {
		return this.indemnity ? "outlined" : "filled";
	}

	getIconSize() {
		return this.getMajorationDetails().customIconeName ? "40px" : "auto";
	}

	showInfoMajoration(event: Event) {
		this.svcPopover.open(
			"",
			event.currentTarget,
			InformationPopoverComponent,
			{}
		)
	}
}
